import * as types from '../constants/ActionTypes-answer';


export const setAnswers = answers => ({
  type: types.SET_ANSWERS,
  payload: answers,
  reducer_type: 'reducer_answer'
});
  
export const fetchAnswerItems = () => ({
  type: types.FETCH_ANSWERS,
  reducer_type: 'reducer_answer'
});

  export const addAnswerItem = newItem => {
    return {
      type: types.ADD_ANSWER_ITEM,
      payload: newItem,
      reducer_type: 'reducer_answer'
    };
  };
  export const addDocumentFlag = id => {
    return {
      type: types.ADD_DOCUMENT_FLAG,
      payload: id,
      reducer_type: 'reducer_answer'
    };
  };
  export const deleteAnswerItem = id => {
    return {
      type: types.DELETE_ANSWER_ITEM,
      payload: id,
      reducer_type: 'reducer_answer'
    };
  };
  
  export const saveAnswerItem = updatedItem => {
    return {
      type: types.SAVE_ANSWER_ITEM,
      payload: updatedItem,
      reducer_type: 'reducer_answer'
    };
  };